import React, { useState } from 'react';
import AdminHeader from '../layout/AdminHeader';
import '../assets/css/admin-toolbar.css';
import VideoDownloadRequest from './video-download-request';
import VideoUploadRequest from './video-upload-request';

function VideoList() {
  const [activeTab, setActiveTab] = useState('download');
  return (
    <div className='main-wrapper main-wrapper-cms video-request'>
      <AdminHeader title="Video Requests" />
      <div className="admin-toolbar">
        <div className="container">
        <div className="video-request-tabs">
          <div
            className={`btn-tabs ${activeTab === 'download' ? 'active' : ''}`}
            onClick={() => setActiveTab('download')}
          >
            Media Download Requests
          </div>
          <div
            className={`btn-tabs ${activeTab === 'upload' ? 'active' : ''}`}
            onClick={() => setActiveTab('upload')}
          >
            Media Upload Requests
          </div>
        </div>
        </div>
      </div>

      {activeTab === 'download' && (
        <VideoDownloadRequest />
      )}
      {activeTab === 'upload' && (
        <VideoUploadRequest />
      )}
    </div>
  );
}

export default VideoList;
